import * as xlsx from "xlsx";
// import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";

function ExportExcel(data , workSheetColumnNames, workSheetName, fileName, header, footer){
    const workBook = xlsx.utils.book_new();
    const workSheeyData = [
        ["", "", "", ""],
        [
            "",
            "",
            "",
            "",
            "",
            `${workSheetName}`,
            "",
        ],
        header,
        workSheetColumnNames,
        ...data,
        footer
    ];
    const workSheet = xlsx.utils.aoa_to_sheet(workSheeyData);
    xlsx.utils.book_append_sheet(workBook, workSheet);
    xlsx.writeFile(workBook, fileName);
}

export default ExportExcel;